import React, { useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
  Container,
  StyledEngineProvider,
  Fab,
  adaptV4Theme,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import MaterialTable from 'material-table';
import api from '../../services/api';
import brLocale from 'date-fns/locale/pt-BR';
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    background: '#F55420',
    '&:hover': {
      backgroundColor: '#fa8c3a',
    },
  },
}));

const tableTheme = createTheme(adaptV4Theme({
  overrides: {
    MuiTableRow: {
      hover: {
        '&:hover': {
          backgroundColor: 'rgba(249, 126, 33, 0.23) !important',
        },
      },
    },
  },
}));

function Samples() {
  const [samples, setSamples] = useState([]);
  const history = useHistory();
  const classes = useStyles();
  const [openProgress, setOpenProgress] = useState(false);

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/samples');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setSamples(response.data);
          setOpenProgress(true);
        }
      } catch (err) {
        // this.setState({ error: "Ocorreu um erro ao tentar carregar" });
      }
    }
    loadData();
  }, []);

  const handleClick = (id) => {
    history.push(`/sample/${id}`);
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={tableTheme}>
        <Container>
          <br />
          <MaterialTable
            title="Amostras"
            columns={[
              {
                title: 'Viveiro',
                field: 'pond',
                hideFilterIcon: true,
              },
              {
                title: 'Ciclo',
                field: 'cycle',
                hideFilterIcon: true,
              },
              {
                title: 'Tamanho',
                field: 'size',
                hideFilterIcon: true,
              },
              {
                title: 'Identificação',
                field: 'description',
                hideFilterIcon: true,
              },
              {
                title: 'Data',
                field: 'date',
                type: 'date',
                hideFilterIcon: true,
              },
            ]}
            data={samples}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <>
                    {openProgress ? (
                      'Nenhum registro para exibir'
                    ) : (
                      <CircularProgress />
                    )}
                  </>
                ),
                filterRow: {
                  filterTooltip: 'Filtro',
                },
                dateTimePickerLocalization: brLocale,
              },
              toolbar: {
                searchTooltip: 'Pesquisar',
                searchPlaceholder: 'Pesquisar',
                exportTitle: 'Exportar',
                exportCSVName: 'Exportar como CSV',
                exportPDFName: 'Exportar como PDF',
              },
              pagination: {
                labelRowsSelect: 'linhas',
                labelDisplayedRows: '{count} de {from}-{to}',
                firstTooltip: 'Primeira página',
                previousTooltip: 'Página anterior',
                nextTooltip: 'Próxima página',
                lastTooltip: 'Última página',
              },
            }}
            options={{
              filtering: true,
              exportButton: true,
              search: true,
              pageSize: 10,
              pageSizeOptions: [10, 15, 20, 50, 100],
              sorting: true,
            }}
            /* actions={[
               {
                 icon: () =>< Icon color="primary" style={{ fontSize: 50 }} >add_circle</Icon>,
                 tooltip: 'Nova inserção',
                 isFreeAction: true,
                 onClick: () =>  history.push("/sample/")
               }
             ]} */
            onRowClick={(evt, rowData) => handleClick(rowData.id)}
          />
          <div>
            <Container>
              <Fab
                component={Link}
                color="primary"
                aria-label="add"
                className={classes.fab}
                to="/sample"
              >
                <AddIcon />
              </Fab>
            </Container>
          </div>
          <br />
        </Container>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
export default Samples;
